<script setup lang="ts">
import { computed, type CSSProperties } from 'vue'
import { usePageLoaded } from '../composables/usePageLoaded'
import type { IconSprite } from '../types/site'

const props = defineProps<{
  sprite: IconSprite
  /** 板块进入预加载范围后才真正下载精灵图 */
  active: boolean
}>()

const pageLoaded = usePageLoaded()

const style = computed<CSSProperties>(() => {
  const { columns, rows, fps, image } = props.sprite
  const loop = props.sprite.loop !== false
  return {
    // 首屏 load 之后才下载，不拖慢微信里的视频自动播放
    backgroundImage: props.active && pageLoaded.value ? `url(${image})` : undefined,
    '--sprite-cols': columns,
    '--sprite-rows': rows,
    '--sprite-scale': props.sprite.scale ?? 1,
    '--sprite-col-duration': `${columns / fps}s`,
    '--sprite-row-duration': `${(columns * rows) / fps}s`,
    '--sprite-col-count': loop ? 'infinite' : rows,
    '--sprite-row-count': loop ? 'infinite' : 1,
  } as CSSProperties
})
</script>

<template>
  <span class="icon-motion__image icon-sprite">
    <span class="icon-sprite__film" :style="style"></span>
  </span>
</template>
